import React, { useState, useEffect } from 'react';
import './GetSupport.css';
import EyeIcon from '../../../../../assets/icons/gardenwall/eye.svg';

const GetSupport = ({ onSupportBlockStatesChange, supportBlocksEnabled }) => {
  const [isEnabled, setIsEnabled] = useState(true);
  const [blockStates, setBlockStates] = useState({});

  const handleToggle = () => {
    setIsEnabled((prev) => !prev);
  };
  /*
  const handleBlockToggle = (id) => {
    setBlockStates((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the state for the specific block
    }));
  };*/

  const handleBlockToggle = (id) => {
    setBlockStates((prev) => {
      const newBlockStates = {
        ...prev,
        [id]: !prev[id], // Toggle the state for the specific block
      };
      onSupportBlockStatesChange(newBlockStates); // Call the passed callback
      return newBlockStates;
    });
  };

  useEffect(() => {
    if (supportBlocksEnabled) {
      setBlockStates(supportBlocksEnabled);
    } else {
      setBlockStates({});
    }
  }, [supportBlocksEnabled]);

  const alerts = [
    {
      id: 1,
      slug: 'upgradeService',
      title: 'Upgrade service',
      icon: 'Upgrade-blue.svg',
    },
    {
      id: 2,
      slug: 'troubleshoot',
      title: 'Troubleshoot',
      icon: 'troubleshoot.svg',
    }, // , color: '#4CAF50'
    { id: 3, slug: 'createTicket', title: 'Create ticket', icon: 'ticket.svg' }, // , color: '#3F51B5'
  ];

  return (
    <div className="card-content">
      <div className="alerts-grid">
        {alerts.map((alert) => {
          let imagePath;
          try {
            imagePath = require(
              `../../../../../assets/icons/gardenwall/${alert.icon}`
            );
          } catch (error) {
            console.error('Image not found for alert:', alert, error);
            imagePath = require(`../../../../../assets/icons/gardenwall/exm.svg`);
          }

          const isBlockEnabled = blockStates?.[alert.slug] !== true;
          // const isBlockEnabled = blockStates?.[alert.id] !== true;
          return (
            <div
              key={alert.id}
              className={`alert-card ${!isBlockEnabled ? '' : 'inactive'}`}
            >
              <div
                className="alert-icon"
                style={{ backgroundColor: alert.color }}
              >
                <img src={imagePath} alt={`${alert.title} Icon`} />
              </div>
              <div className="alert-title">{alert.title}</div>
              <div
                className="alert-eye"
                onClick={() => handleBlockToggle(alert.slug)}
              >
                <img src={EyeIcon} alt="Eye Icon" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GetSupport;

